window.addEventListener("DOMContentLoaded", ()=>{
$(document).ready(function () {
  // const demoResponse = {
  //   "success": true,
  //   "status": "",
  //   "order_status": "available",
  //   "courier": null,
  //   "current_status": "current status",
  //   "tracking_details": [
  //     {
  //       "status": "Ready for Courier",
  //       "date": "2025-06-18 04:43:17"
  //     },
  //     {
  //       "status": "Picking In-Process",
  //       "date": "2025-06-18 08:25:03"
  //     },
  //     {
  //       "status": "Picked",
  //       "date": "2025-06-18 08:35:07"
  //     },
  //     {
  //       "status": "Booked",
  //       "date": "2025-06-18 09:44:19"
  //     }
  //   ],
  //   "courier_status": null,
  //   "error": ""
  // };
  

  const statusLabels = {
    "Awaiting Confirmation": "Order Recieved",
    "Review": "Order Recieved",
    "Ready for Courier": "Order Recieved",
    "Picking In-Process": "Picking In-Process",
    "Picked": "Picked",
    "Booked": "Booked",
    "Shipped": "Shipped",
    "Delivered": "Delivered",
    "Return": "Returned",
    "Canceled": "Your order has been Canceled",
  };

  function renderTrackingSteps(response, orderId) {
    $('#orderNum').text(orderId);
    if (!response || !response.success || response.order_status=='N/A') {
      $('#order-tracker-container').html('<div class="no-response-message w-100"><p class="error">Your order is being processed. Tracking information will be available once it is picked by the courier.</p></div>');
      $(".track-back-btn").show();
      return;
    }


    let stepsHtml = '';
    const trackingMap = {};


    // Convert tracking_details into a map for quick lookup (using trimmed lowercase keys)
    for (const [cn, courier] of Object.entries(response.tracking_details)) {
    const keyMapping = [];
      
      if(cn == "" || cn == null) {
        $('#order-tracker-container').html(`
          <div class="no-tracking-message">
            <p>Your order is being processed. Tracking information will be available once it's picked by the courier.</p>
          </div>
        `);
          $(".tracking-order-form").show();
          $(".tracking-result").show();
        return;
      }
      courier.status_history.forEach(item => {
        const statusKey = item.status.trim();
        trackingMap[statusKey] = item.date;
      });
      stepsHtml += ` <div class="courier-details">
                      <div class="cn-details-container">
                        <div class="courier-logo">
                          <img src="${courier.courier_logo.replace(":8080","")}" alt="${courier.courier}" width="150" height="100" class="courier-logo-img"/>
                        </div>`
          stepsHtml += `<div class="fbr-invoice">${fbrInvoiceHtml(courier.fbr_invoice)}</div>`;
      
         stepsHtml += `<div class="courier-info">
                          <span class="cn-details cn-name">Courier: <strong>${courier.courier}</strong></span>
                          <span class="cn-details cn-number">Tracking #: <strong>${cn}</strong></span>
                          <span class="cn-details cn-status">Status: <strong>${courier.courier_status}</strong></span>`;
                        if(courier.cod_amount && courier.cod_amount != null) 
                        {
                          stepsHtml += `<span class="cn-details cn-date">COD Amount: <strong>${toPrice(courier.cod_amount)}</strong></span>`;
                        }
                        else
                        {
                          stepsHtml += `<span class="cn-details cn-date"><strong>Prepaid Order</strong></span>`;
                        }
                        stepsHtml += `</div>
                      </div>
                      <div class="items-details">
                        <div class="items-title">Product Information</div>
                        <div class="items-list">`;
      courier.items.forEach(item => {
        stepsHtml += `<a class="item" data-item-id="${item.sku}" href="${item.url}" target="_blank">
                        <div class="item-image-container">
                          <img src="${item.image}${item.image.includes('?') ? '&width=100' : '?width=100'}" alt="${item.name}" width="100" height="100" class="item-image"/>
                        </div>
                        <div class="item-info">
                          <div class="item-name">${item.name}</div>
                          <div class="item-variant">`;
        if(item.color && item.color != null) {
          stepsHtml += `    <span class="item-color"><strong>Color: ${item.color}</strong></span>`;
        }
        if(item.size && item.size != null) {
          stepsHtml += `    <span class="item-size"><strong>Size: ${item.size}</strong></span>`;
        }
        stepsHtml += `      <span class="item-quantity">Qty: ${item.qty}</span>
                          </div>
                        </div>
                      </a>`;
      });         
      stepsHtml +=    `</div><hr/></div>
                      <div class="order-tracker tracking-steps">`;
      Object.keys(statusLabels).forEach(function (key) {
        const hasStatus = key in trackingMap;
        if(keyMapping.includes(statusLabels[key])) return; // Skip if already added
        keyMapping.push(statusLabels[key]);
        const dateText = hasStatus
          ? new Date(trackingMap[key]).toLocaleDateString('en-US', {
            weekday: 'short',
            day: 'numeric',
            month: 'short'
          })
          : 'soon';

        stepsHtml += `
        <div class="step ${hasStatus ? 'active' : 'inactive'} ${statusLabels[key]}">
          <div class="circle"></div>
          <span class="line"></span>
          <div class="tracking-info">
            <p class="label">${statusLabels[key]}</p>
            <p class="date">${dateText}</p>
          </div>
        </div>
      `;
      });
      stepsHtml += "</div></div>";
    }

    // console.log("Tracking Map:", trackingMap);

    $('#order-tracker-container').addClass("status-"+response.order_status);
    $('a.link.back-account.link-underline').attr('href', location.pathname);
    
    if (Object.keys(trackingMap).length === 0) {
      $('#order-tracker-container').html(`
      <div class="no-tracking-message">
        <p>Your order is being processed. Tracking information will be available once it's picked by the courier.</p>
      </div>
    `);
      $(".track-back-btn").show();

      return;
    }
    // Loop over predefined steps (in correct sequence)
    $('#order-tracker-container').html(stepsHtml);
  }

  // fbr_invoice.file is a "data:application/pdf;base64,..." URI; convert to a Blob
  // so large PDFs download reliably instead of hitting data-URI length limits.
  function fbrInvoiceHtml(invoice) {
    if (!invoice || !invoice.file || !invoice.invoice_no) return '';
    try {
      const base64 = invoice.file.split(',')[1];
      const bytes = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
      const url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
      return `<span class="cn-details fbr-invoice-no">FBR Invoice #: <strong>${invoice.invoice_no}</strong></span>
              <a class="button fbr-invoice-download" href="${url}" download="FBR-Invoice-${invoice.invoice_no}.pdf">Download FBR Invoice</a>`;
    } catch (e) {
      console.error('Could not render FBR invoice', e);
      return '';
    }
  }

  function fetchTrackingData(orderId) {
      if (!orderId) return;

      $(".tracking-order-form").hide();
      $(".basic-loader").show();
      $(".tracking-result").hide();
      history.replaceState({}, '', location.origin + location.pathname + '?track_order=' + encodeURIComponent(orderId));
      $.ajax({
          url: 'https://www.gulahmedshop.com/apps/izooto/track-order?new_json=true&order_or_cn=' + encodeURIComponent(orderId),
          method: 'GET',
          success: function (response) {
            if(response.success){
              $(".basic-loader").hide();
              $(".tracking-result").show();
              renderTrackingSteps(response, response.order_no);
            }else{
              $(".basic-loader").hide();
              $(".tracking-result").show();
              $('#orderNum').text(orderId);
              $("#order-tracker-container").html(`<p class="error w-100">${response.error}</p>`);
              $(".track-back-btn").show();

            }
          },
          error: function () {
              $(".basic-loader").hide();
              $("#order-tracker-container").html('<p class="error">Could not fetch tracking data. Try again.</p>');
              $(".track-back-btn").show();

          }
      });
  }


  function toPrice(num) {
    return new Intl.NumberFormat('en-PK', {
      style: 'currency',
      currency: 'PKR',
      maximumFractionDigits: 0
    }).format(num);
  }

  // function fetchTrackingData(orderId) {
  //   if (!orderId) return;

  //   $(".tracking-order-form").hide();
  //   // showing loader for demo
  //   $(".basic-loader").show();
  //   setTimeout(function () {
  //     $(".basic-loader").hide();
  //     $(".tracking-result").show();
  //     renderTrackingSteps(demoResponse, orderId);
  //   }, 3000);


  //   // Simulate AJAX result
  //   // In a real scenario, you would replace this with an AJAX call to your server
  //   // $.ajax({
  //   //     url: '/apps/tracking-api?order=' + encodeURIComponent(orderId),
  //   //     method: 'GET',
  //   //     success: function (response) {
  //   //         renderTrackingSteps(response, orderId);
  //   //     },
  //   //     error: function () {
  //   //         $('#order-tracker-container').html('<p class="error">Could not fetch tracking data. Try again.</p>');
  //   //     }
  //   // });

  // }


  $('#trackOrderBtn').on('click', function (e) {
    e.preventDefault();
    var orderId = $('#trackOrder').val().trim();
    if (orderId === '') {
      alert("Please enter your Order ID or Tracking Number.");
      return;
    }
    fetchTrackingData(orderId);
  });
  
  if(location.search.includes('track_order')) {
    const urlParams = new URLSearchParams(window.location.search);
    const orderParam = urlParams.get('track_order');
    fetchTrackingData(orderParam);
  }
  else {
    $(".tracking-result").hide();
    $(".tracking-order-form").show();
  }
});
});